import styled, { css } from 'styled-components'

export const HeadBarStyled = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 50px;
    padding: 5px 0;
    width: 100%;
    background: ${({ theme }) => theme.whiteTwo};
    z-index: 5;
    ${({ noShadow }) =>
        !noShadow &&
        css`
            box-shadow: 0 2px 8px 0 rgba(228, 228, 241, 0.29);
        `
    };
`

export const HeadBarContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
`

export const BackButton = styled.div`
    cursor: pointer;
`

export const Title = styled.div`
    font-size: 16px;
    font-weight: 700;
    line-height: 1em;
    text-align: center;
`

export const LeftButtons = styled.div`
    display: flex;
    justify-content: flex-start;
    min-width: 80px;
    margin-left: 5px;
`

export const RightButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-width: 80px;
    margin-left: 5px;
    > div ~ div {
        margin-left: 25px;
    }
    > span ~ span {
        margin-left: 25px;
    }
    > button ~ button {
        margin-left: 25px;
    }
`

